<template>
  <div>
    <va-modal
      class="modal"
      v-model="showCreatePartenaire"
      cancelClass="none"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="createPartenaire"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="forcewidth">
        <div class="row">
          <div class="flex md3">
            <h5 :style="{ color: this.$themes.primary }">{{partenaire.nom}}</h5>
          </div>

          <div class="flex md9">
            <div class="row row-inside">
              <div class="flex md3" v-show="partenaire.isactive"></div>
              <div class="flex md2">
                <va-button
                  class="custom-button"
                  small
                  :disabled="!partenaire.email"
                  @click="openCourriel(partenaire)"
                >Courriel</va-button>
              </div>
              <div class="flex md2 pl-4">
                <va-checkbox label="Vérifier" v-model="verifierPartenaire" />
              </div>

              <div class="flex md2">
                <va-toggle small v-model="partenaire.isactive" label="En activité" />
              </div>

              <div class="flex md3" v-show="!partenaire.isactive">
                <va-date-picker
                  class="warning-date px-2"
                  :config="{ dateFormat: 'd-m-Y' }"
                  label="Date de fin d'activité"
                  v-model="partenaire.fin_activite"
                  removable
                  :error="!partenaire.isactive && !partenaire.fin_activite"
                />
              </div>
              <div class="flex md3">
                <va-date-picker
                  class="px-2"
                  :config="{ dateFormat: 'd-m-Y' }"
                  label="Date de début d'activité"
                  v-model="partenaire.debut_activite"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="flex md6">
            <va-tabs v-model="tabsState">
              <va-tab>Fiche partenaire</va-tab>
            </va-tabs>
            <va-separator />
          </div>
        </div>
        <div class="row">
          <div class="flex md8">
            <div class="row">
              <div class="flex md6">
                <va-input
                  v-model="partenaire.nom"
                  placeholder="Nom partenaire"
                  label="Nom"
                  :error="pValidNom"
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md4">
                <va-input v-model="partenaire.email" placeholder="Courriel" label="Courriel" />
              </div>
              <div class="flex md2 px-2">
                <va-input
                  v-model="phoneNumberPartenaire"
                  placeholder="Telephone"
                  label="Telephone"
                  v-on:paste="trimOnPaste('telephonePartenaire')"
                  v-on:focus="phoneNumberPartenaire = removeWhiteSpace(phoneNumberPartenaire)"
                  v-on:blur="phoneNumberPartenaire = formatPhoneNumber(phoneNumberPartenaire)"
                  :error="!isValidPhoneNumber(phoneNumberPartenaire)"
                />
              </div>
              <div class="flex md2 pr-2">
                <va-input
                  v-model="portableNumberPartenaire"
                  placeholder="Portable"
                  label="Portable"
                  v-on:paste="trimOnPaste('portablePartenaire')"
                  v-on:focus="portableNumberPartenaire = removeWhiteSpace(portableNumberPartenaire)"
                  v-on:blur="portableNumberPartenaire = formatPhoneNumber(portableNumberPartenaire)"
                  :error="!isValidPhoneNumber(portableNumberPartenaire)"
                />
              </div>
              <div class="flex md4">
                <va-input
                  v-model="partenaire.site_internet"
                  placeholder="Site internet"
                  label="Site internet"
                />
              </div>
            </div>
            <div class="row">
              <div class="flex md12 my-1">
                <h6>Contact principal</h6>
              </div>
            </div>
            <div class="row">
              <div class="flex md2">
                <va-select
                  label="Civilité"
                  v-model="contact.titre"
                  :options="titreOptions"
                  no-clear
                />
              </div>
              <div class="flex md3 px-2">
                <va-input
                  v-model="contact.nom"
                  placeholder="Contact inconnu"
                  label="Nom"
                  :error="cValidNom"
                />
              </div>
              <div class="flex md3">
                <va-input
                  :disabled="contact.titre==='SOCIÉTÉ'"
                  v-model="contact.prenom"
                  placeholder="-"
                  label="Prénom"
                />
              </div>
              <div class="flex md4 pl-2">
                <va-input v-model="contact.titre_honorifique" placeholder="Titre" label="Titre" />
              </div>
            </div>
            <div class="row" v-if="contact.titre==='SOCIÉTÉ'">
              <div class="flex md2">
                <va-select
                  label="Civilité contact"
                  v-model="contact.titre_societe"
                  :options="titreOptionsSociete"
                  no-clear
                />
              </div>
              <div class="flex md3 px-2">
                <va-input
                  v-model="contact.nom_societe"
                  placeholder="Contact inconnu"
                  label="Nom contact"
                />
              </div>
              <div class="flex md3">
                <va-input v-model="contact.prenom_societe" placeholder="-" label="Prénom contact" />
              </div>
            </div>
            <div class="row">
              <div class="flex md4">
                <va-input v-model="contact.email" placeholder="Courriel" label="Courriel" />
              </div>
              <div class="flex md2 px-2">
                <va-input
                  v-model="phoneNumberContact"
                  placeholder="Telephone"
                  label="Telephone"
                  v-on:paste="trimOnPaste('telephoneContact')"
                  v-on:focus="phoneNumberContact = removeWhiteSpace(phoneNumberContact)"
                  v-on:blur="phoneNumberContact = formatPhoneNumber(phoneNumberContact)"
                  :error="!isValidPhoneNumber(phoneNumberContact)"
                />
              </div>
              <div class="flex md2 pr-2">
                <va-input
                  v-model="portableNumberContact"
                  placeholder="Portable"
                  label="Portable"
                  v-on:paste="trimOnPaste('portableContact')"
                  v-on:focus="portableNumberContact = removeWhiteSpace(portableNumberContact)"
                  v-on:blur="portableNumberContact = formatPhoneNumber(portableNumberContact)"
                  :error="!isValidPhoneNumber(portableNumberContact)"
                />
              </div>
              <div class="flex md3 pl-4">
                <va-checkbox label="Adresse identique" v-model="sameAdresse" />
              </div>
            </div>
          </div>
          <div class="flex md4 px-4">
            <div class="flex md12">
              <va-tabs grow v-model="tabsStateAdresses">
                <va-tab>Adresse principale</va-tab>
                <va-tab v-if="!sameAdresse">Adresse contact</va-tab>
              </va-tabs>
              <va-separator />
            </div>
            <div v-show="tabsStateAdresses===0" class="row">
              <div class="flex md12">
                <va-input
                  v-model="adresse_partenaire.adresse"
                  placeholder="Adresse inconnue"
                  label="Adresse"
                />
              </div>
              <div class="flex md12">
                <va-input
                  v-model="adresse_partenaire.complement"
                  placeholder="Complement d'adresse"
                  label="Adresse suite"
                />
              </div>
              <div class="flex md3">
                <va-input
                  v-model="adresse_partenaire.code_postal"
                  placeholder="Code Postal"
                  label="Code Postal"
                  :error="pValidCP"
                />
              </div>
              <div class="flex md6 px-2">
                <va-input
                  v-model="adresse_partenaire.ville"
                  placeholder="Ville"
                  label="Ville"
                  :error="pValidVille"
                />
              </div>
              <div class="flex md3">
                <va-input v-model="adresse_partenaire.cedex" placeholder="Cedex" label="Cedex" />
              </div>
            </div>
            <div v-show="tabsStateAdresses===1" class="row">
              <div class="flex md12">
                <va-input
                  v-model="adresse_contact.adresse"
                  placeholder="Adresse inconnue"
                  label="Adresse"
                />
              </div>
              <div class="flex md12">
                <va-input
                  v-model="adresse_contact.complement"
                  placeholder="Complement d'adresse"
                  label="Adresse suite"
                />
              </div>
              <div class="flex md3">
                <va-input
                  v-model="adresse_contact.code_postal"
                  placeholder="Code Postal"
                  label="Code Postal"
                  :error="cValidCP"
                />
              </div>
              <div class="flex md6 px-2">
                <va-input
                  v-model="adresse_contact.ville"
                  placeholder="Ville"
                  label="Ville"
                  :error="cValidVille"
                />
              </div>
              <div class="flex md3">
                <va-input v-model="adresse_contact.cedex" placeholder="Cedex" label="Cedex" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import uuid from "uuid/v4";
import moment from "moment";

import { isPhoneNumber, removeWhiteSpace } from "../../services/utils";

export default {
  name: "fichePartenaire",
  props: ["value"],
  data() {
    return {
      sameAdresse: true,
      titreOptionsSociete: ["MONSIEUR", "MADAME"],
      titreOptions: ["MONSIEUR", "MADAME", "SOCIÉTÉ"],
      isAnnonceur: false,
      showJournal: false,
      verifierPartenaire: false,
      tabsState: 0,
      tabsStateAdresses: 0,
      showCreatePartenaire: false,
      phoneNumberPartenaire: null,
      portableNumberPartenaire: null,
      phoneNumberContact: null,
      portableNumberContact: null,
      partenaire: {
        isactive: true,
        nom: null,
        debut_activite: null,
        fin_activite: null,
        site_internet: null,
        telephone: null,
        portable: null,
        email: null
      },
      contact: {
        titre: null,
        nom: null,
        prenom: null,
        telephone: null,
        email: null,
        portable: null,
        note: null,
        fonction: null,
        isactif: null,
        nom_societe: null,
        prenom_societe: null,
        titre_societe: null,
        titre_honorifique: null
      },
      adresse_partenaire: {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null
      },
      adresse_contact: {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null
      }
    };
  },
  mounted() {
    this.resetValues();
    this.showCreatePartenaire = this.value; // initialize internal variables
  },

  methods: {
    isValidPhoneNumber(str) {
      if (!str) {
        return true;
      }
      return isPhoneNumber(removeWhiteSpace(str));
    },
    resetValues() {
      this.verifierPartenaire = false;
      this.tabsState = 0;
      this.tabsStateAdresses = 0;
      this.sameAdresse = true;
      this.phoneNumberPartenaire = null;
      this.portableNumberPartenaire = null;
      this.phoneNumberContact = null;
      this.portableNumberContact = null;
      this.partenaire = {
        isactive: true,
        nom: null,
        debut_activite: null,
        fin_activite: null,
        site_internet: null,
        telephone: null,
        portable: null,
        email: null
      };
      this.contact = {
        titre: null,
        nom: null,
        prenom: null,
        telephone: null,
        email: null,
        portable: null,
        note: null,
        fonction: null,
        isactif: null,
        nom_societe: null,
        prenom_societe: null,
        titre_societe: null,
        titre_honorifique: null
      };
      this.adresse_partenaire = {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null
      };
      this.adresse_contact = {
        code_postal: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null
      };
    },
    closeModal() {
      this.resetValues();
      this.$emit("input", false);
    },
    async createPartenaire() {
      this.showCreatePartenaire = true;
      if (!this.isComplete) {
        this.launchEpicmaxToast("Information incomplètes");
      } else {
        // validate all informations that need to be sent
        // partenaire:
        let partenaire = this.partenaire;
        if (!partenaire.nom) {
          this.launchEpicmaxToast("Le nom du partenaire doit être renseigné");
          return;
        }

        if (this.isValidPhoneNumber(this.phoneNumberPartenaire)) {
          partenaire.telephone = this.phoneNumberPartenaire;
        } else if (this.phoneNumberPartenaire) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }

        if (this.isValidPhoneNumber(this.portableNumberPartenaire)) {
          partenaire.portable = this.portableNumberPartenaire;
        } else if (this.portableNumberPartenaire) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }

        if (!partenaire.isactive) {
          if (!partenaire.fin_activite) {
            this.launchEpicmaxToast("Date de fin d’activitée non renseignée");
            return;
          }
          partenaire.fin_activite = moment(
            partenaire.fin_activite,
            "DD-MM-YYYY"
          ).format("YYYY-MM-DD");
        }

        if (partenaire.debut_activite) {
          partenaire.debut_activite = moment(
            partenaire.debut_activite,
            "DD-MM-YYYY"
          ).format("YYYY-MM-DD");
        }

        //contact principal
        let contact = this.contact;
        if (!contact.nom) {
          this.launchEpicmaxToast("Le nom du contact doit être renseigné");
          return;
        }

        if (this.isValidPhoneNumber(this.phoneNumberContact)) {
          contact.telephone = this.phoneNumberContact;
        } else if (this.phoneNumberContact) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }

        if (this.isValidPhoneNumber(this.portableNumberContact)) {
          contact.portable = this.portableNumberContact;
        } else if (this.portableNumberContact) {
          this.launchEpicmaxToast("Numéro de téléphone invalide");
          return;
        }

        //adresse principale
        let adresse_partenaire = this.adresse_partenaire;
        if (!adresse_partenaire.code_postal || !adresse_partenaire.ville) {
          this.launchEpicmaxToast("Adresse incomplète");
        }

        //adresse contact
        let adresse_contact = this.adresse_contact;
        if (
          !this.sameAdresse &&
          (!adresse_contact.code_postal || !adresse_contact.ville)
        ) {
          this.launchEpicmaxToast("Adresse du contact incomplète");
        }
        contact.haveAdresse = !this.sameAdresse;

        //send for creation

        let params = {
          partenaire: partenaire,
          contact: contact,
          adresse_partenaire: adresse_partenaire,
          adresse_contact: adresse_contact,
          verification: this.verifierPartenaire
        };

        let res = await axios.post("/api/partenaire/create", params);

        let idpartenaire = res.data.idpartenaire;

        //open fiche partenaire for the newly created entity
        this.$emit("create", idpartenaire);
        this.closeModal();
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    },
    openCourriel(entreprise) {
      let email = partenaire.email;
      window.location.href = "mailto:" + email;
    },
    trimOnPaste(entry) {
      if (entry == "telephonePartenaire") {
        setTimeout(() => {
          this.phoneNumberPartenaire = this.removeWhiteSpace(
            this.phoneNumberPartenaire
          );
        }, 200);
      }
      if (entry == "portablePartenaire") {
        setTimeout(() => {
          this.portableNumberPartenaire = this.removeWhiteSpace(
            this.portableNumberPartenaire
          );
        }, 200);
      }
      if (entry == "telephoneContact") {
        setTimeout(() => {
          this.phoneNumberContact = this.removeWhiteSpace(
            this.phoneNumberContact
          );
        }, 200);
      }
      if (entry == "portableContact") {
        setTimeout(() => {
          this.portableNumberContact = this.removeWhiteSpace(
            this.portableNumberContact
          );
        }, 200);
      }
    },
    removeWhiteSpace(str) {
      if (str) return str.replace(/ /g, "");
      return null;
    },
    isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && (String(n) === str || n === str) && n >= 0;
    },
    formatPhoneNumber(str) {
      if (isPhoneNumber(str)) {
        let newStr =
          str.slice(0, 2) +
          " " +
          str.slice(2, 4) +
          " " +
          str.slice(4, 6) +
          " " +
          str.slice(6, 8) +
          " " +
          str.slice(8, 10);
        return newStr;
      }
      return str;
    }
  },
  computed: {
    isComplete: function() {
      let bool =
        !this.pValidNom &&
        !this.cValidNom &&
        !this.pValidCP &&
        !this.pValidVille;
      if (!this.sameAdresse) {
        bool = bool & !this.cValidCP && !this.cValidVille;
      }
      return bool;
    },
    saveMessage: function() {
      return this.isComplete
        ? "Créer le partenaire"
        : "Information incomplètes";
    },
    pValidNom: function() {
      if (this.partenaire.nom && this.partenaire.nom.length < 200) {
        return false;
      }
      return true;
    },
    cValidNom: function() {
      if (this.contact.nom && this.contact.nom.length < 200) {
        return false;
      }
      return true;
    },
    pValidCP: function() {
      if (this.adresse_partenaire.code_postal) {
        return false;
      }
      return true;
    },
    pValidVille: function() {
      if (this.adresse_partenaire.ville) {
        return false;
      }
      return true;
    },
    cValidVille: function() {
      if (this.adresse_contact.ville) {
        return false;
      }
      return true;
    },
    cValidCP: function() {
      if (this.adresse_contact.code_postal) {
        return false;
      }
      return true;
    }
  },
  watch: {
    sameAdresse(newvalue) {
      if (newvalue) {
        this.tabsStateAdresses = 0;
      }
    },
    value() {
      // Parent property changed; update internal variables
      this.showCreatePartenaire = this.value;
      this.resetValues();
    }
  }
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 85vw;
  height: 75vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.custom-button {
  width: 90%;
  border-color: #40e583;
  border-width: 2px;
  border-style: solid;
  position: relative;
  top: -0.3em;
}
</style>
